import React from 'react';
import StoreHero from './StoreHero';
import StoreTotalCard from './StoreTotalCard';
import StorePeopleBlock from './StorePeopleBlock';
import StoreKpiSection from './StoreKpiSection';
import { bucketsModel, heroModel, pickShop } from '../../utils/storeView';

/**
 * 店舗タブ「この店舗」の本体: 上段（目標を設定した人の売上）→ 下段（参考: 店舗全体の売上）→ 人数ブロック（管理者のみ）
 * → KPI カード（全項目）→ KPI ごとのグラフ。
 * summary / buckets は hooks/useStoresData の戻り値（{ data, loading, error }）。
 * 数字はすべて store-summary（個人名なし）。人数ブロックだけ、管理者ロールの store-buckets。
 */
export default function StoreOneView({ summary, buckets, shop, isAdmin, selectedMonth, onOpenRoster }) {
  const { data, loading, error } = summary;
  if (loading && !data) return <div className="scope-empty">読み込み中…</div>;
  if (error) return <div className="scope-empty">店舗の数字を読み込めませんでした。もう一度お試しください</div>;

  const stores = data?.stores || [];
  if (stores.length === 0) return <div className="scope-empty">表示できる店舗がありません</div>;

  const name = pickShop(stores, shop);
  const entry = stores.find((s) => s.store === name);
  const bucketEntry = buckets?.data?.stores?.find((s) => s.store === name);
  const hero = heroModel(entry, data, { isAdmin });

  return (
    <>
      <StoreHero hero={hero} />
      <StoreTotalCard hero={hero} onOpenRoster={isAdmin ? () => onOpenRoster?.(name) : undefined} />
      {isAdmin && bucketEntry && (
        <StorePeopleBlock
          model={bucketsModel(bucketEntry, buckets.data.judged)}
          onOpenRoster={() => onOpenRoster?.(name)}
        />
      )}
      <StoreKpiSection entry={entry} selectedMonth={selectedMonth} />
    </>
  );
}
